/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class WizqApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint().');
        }
        if (requestParameters['jsonData'] == null) {
            throw new runtime.RequiredError('jsonData', 'Required parameter "jsonData" was null or undefined when calling fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['jsonData'] != null) {
            formParams.append('JsonData', requestParameters['jsonData']);
        }
        const response = await this.request({
            path: `/api/v1/wizq/proxyRequestHandler/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint(game, jsonData, initOverrides) {
        await this.fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRaw({ game: game, jsonData: jsonData }, initOverrides);
    }
}
//# sourceMappingURL=WizqApi.js.map